module.exports = __webpack_public_path__ + "static/media/31-8.32407f5c.mp3";